module.exports = __webpack_public_path__ + "img/STERiJECT_00_2.8533c864.png";